import React, { useEffect, useState } from "react";

const Filterswhishlist = ({
  cards,
  onFilterChange,
  onSortChange,
  onSearchChange,
}) => {
  const [languageData, setLanguageData] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);
  const [activeSortOption, setActiveSortOption] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/experts/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  const handleLinkClick = (filterName) => {
    const formattedFilterName =
      filterName.charAt(0).toUpperCase() + filterName.slice(1);

    if (filterName === "male" || filterName === "female") {
      const otherGender = filterName === "male" ? "female" : "male";
      const newFilters = activeFilters
        .filter((f) => f !== otherGender)
        .filter((f) => f !== filterName);

      const updatedFilters = newFilters.includes(filterName)
        ? newFilters
        : [...newFilters, filterName];

      setActiveFilters(updatedFilters);
      onFilterChange(updatedFilters);
    } else {
      const newFilters = activeFilters.includes(filterName)
        ? activeFilters.filter((f) => f !== filterName)
        : [...activeFilters, filterName];

      setActiveFilters(newFilters);
      onFilterChange(newFilters);
    }
  };

  const handleSortOptionClick = (optionName) => {
    setActiveSortOption(optionName === activeSortOption ? null : optionName);
    onSortChange(optionName === activeSortOption ? null : optionName);
  };
  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    onSearchChange(value);
  };

  const handleReset = () => {
    setActiveFilters([]);
    setActiveSortOption(null);
    setSearchValue("");
    onFilterChange([]);
    onSortChange(null);
    onSearchChange("");
  };

  const shouldHideResetButton =
    activeFilters.length === 0 && activeSortOption === null && !searchValue;

  return (
    <div className="col-xxl-12 col-xl-12 col-md-12 text-start">
      <div className="card custom-card">
        <div className="card-body p-0">
          <nav className="navbar navbar-expand-xxl bg-white">
            <div className="container">
              <h6 className="mb-0 me-2 text-muted">
                {languageData.filters.title}:
              </h6>
              <button data-interaction="filter_wishlist_button"
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse navbar-justified"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav me-auto align-items-xxl-center resp-my-1 resp-al-center flex flex-row align-items-center">
                  {["available", "favorite"].map((filter) => (
                    <li
                      className="nav-item mr-8p flex"
                      key={filter}
                    >
                      <button data-interaction="sort_by"
                        className={`nav-link ${
                          activeFilters.includes(filter) ? "active" : ""
                        }`}
                        href="#"
                        onClick={() => handleLinkClick(filter)}
                      >
                        {languageData.filters[filter]}
                      </button>
                    </li>
                  ))}

                  <li
                    className="nav-item dropdown drop_resp flex"
                  >
                    <a data-interaction="wishlist_sort_by_button "
                      className="nav-link btn  btn-primary-light dropdown-toggle position-relative"
                      type="button"
                      data-bs-toggle="dropdown"
                    >
                      {languageData.filters.sort}
                    </a>
                    <ul className="dropdown-menu position-absolute">
                      {["reading", "newest", "rating"].map(
                        (sortOption) => (
                          <li key={sortOption}>
                            <a data-interaction="sort_dropdown"
                              className={`dropdown-item ${
                                activeSortOption === sortOption ? "active" : ""
                              }`}
                              href="#"
                              onClick={() => handleSortOptionClick(sortOption)}
                            >
                              {languageData.filters[`sort_${sortOption}`]}
                            </a>
                          </li>
                        ),
                      )}
                    </ul>
                  </li>
                  {!shouldHideResetButton && (
                    <li className="nav-item">
                      <button data-interaction="wishlist_reset_button"
                        className="btn btn-sm btn-reset"
                        onClick={handleReset}
                        
                      >
                        {languageData.filters.reset || "Reset"}
                      </button>
                    </li>
                  )}
                </ul>
                <div className="d-flex ml-1" role="search">
                  <input
                    className="form-control form-control-sm me-2"
                    type="search"
                    name="search"
                    placeholder={languageData.filters.search}
                    aria-label="Search"
                    value={searchValue}
                    onChange={handleSearchChange}
                  />
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Filterswhishlist;
